"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _constants = require("../constants");
var _tooltip = _interopRequireDefault(require("./tooltip"));
var _theme = require("../../birch/components/buttons/icon_buttons/theme");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var ICON_SIZES = {
  small: '16px',
  medium: '20px'
};
var BUTTON_SIZES = {
  small: '24px',
  medium: '32px'
};
var AzaleaStyles = {
  disabled: {
    iconColor: _constants.colors.mediumLightGrey
  },
  "default": {
    hoverBackgroundColor: _constants.colors.toddlerBlue,
    iconColor: _constants.colors.mediumGrey
  }
};
var BirchStyles = {
  disabled: {
    iconColor: _constants.colors.mediumLightGrey
  },
  "default": {
    hoverBackgroundColor: _theme.IconButtonTheme.hover.backgroundColor,
    iconColor: _theme.IconButtonTheme.iconColor
  }
};
var versionSelector = (0, _constants.buildVersionSelector)(AzaleaStyles, BirchStyles);
var StyledButton = _styledComponents["default"].button.withConfig({
  displayName: "icon_button__StyledButton"
})(["background-color:transparent;border-color:transparent;padding:0;border-radius:100%;", " height:", ";", " width:", ";svg{vertical-align:middle;path{fill:", ";}}", " ", ""], /* @ts-expect-error Flow -> TS migration */'', function (props) {
  return props.size;
}, /* @ts-expect-error Flow -> TS migration */'', function (props) {
  return props.size;
}, function (_ref) {
  var theme = _ref.theme;
  return versionSelector(theme === null || theme === void 0 ? void 0 : theme.name)["default"].iconColor;
}, function (props) {
  var _props$theme, _props$theme2;
  return !props.disabled && "\n    cursor: pointer;\n\n    &:active {\n      box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.15);\n    }\n\n    &:hover,\n    &:focus {\n      background-color: ".concat(versionSelector((_props$theme = props.theme) === null || _props$theme === void 0 ? void 0 : _props$theme.name)["default"].hoverBackgroundColor, ";\n      svg {\n        path {\n          fill: ").concat(versionSelector((_props$theme2 = props.theme) === null || _props$theme2 === void 0 ? void 0 : _props$theme2.name)["default"].iconColor, ";\n        }\n      }\n    }\n  ");
}, function (props) {
  var _props$theme3, _props$theme4;
  return props.disabled && "\n    cursor: default;\n\n    svg {\n      path {\n        fill: ".concat(versionSelector((_props$theme3 = props.theme) === null || _props$theme3 === void 0 ? void 0 : _props$theme3.name).disabled.iconColor, ";\n      }\n    }\n\n    &:hover,\n    &:focus {\n      svg {\n        cursor: default;\n\n        path {\n          fill: ").concat(versionSelector((_props$theme4 = props.theme) === null || _props$theme4 === void 0 ? void 0 : _props$theme4.name).disabled.iconColor, ";\n        }\n      }\n    }\n  ");
});
var IconButton = function IconButton(props) {
  var Icon = props.Icon,
    onClick = props.onClick,
    size = props.size,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    label = props.label,
    className = props.className;
  return /*#__PURE__*/React.createElement(_tooltip["default"], {
    placement: "top",
    content: label,
    className: className
  }, /*#__PURE__*/React.createElement(StyledButton
  // @ts-expect-error - TS2769 - No overload matches this call.
  , {
    size: BUTTON_SIZES[size],
    onClick: onClick,
    disabled: disabled,
    "aria-label": label,
    "data-provides": props['data-provides']
  }, /*#__PURE__*/React.createElement(Icon, {
    size: ICON_SIZES[size],
    marginLeft: "0",
    marginRight: "0"
  })));
};
var ThemedIconButton = (0, _styledComponents.withTheme)(IconButton);
var _default = exports["default"] = ThemedIconButton;